<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <div class="form-card-wrapper">
              <b-card header-tag="header">
                <template #header>
                  <b>Contenuto</b>
                </template>
                <b-card-text>
                  <b-row>
                    <div class="form-group">
                      <base-input
                        name="title"
                        vid="title"
                        label="Titolo"
                        v-model="form[rep].title"
                        placeholder="Inserisci un titolo"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Tipo"
                        v-model="form[rep].type"
                        :options="types"
                        :taggable="false"
                        :multiple="false"
                        :rules="{ required: true }"
                      />
                    </div>
                  </b-row>
                  <div class="col-md-12">
                    <label>Testo SMS:</label>
                    <base-editor-sms
                      editor_id="sms_text_content"
                      :height="500"
                      v-model="form[rep].text_content"
                      :isEdit="true"
                      @onInitEditEditor="onInitEditEditor"
                      @updateEditorContent="updateEditorContent"
                    />
                  </div>
                </b-card-text>
              </b-card>
            </div>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button>
                  </span>
                  <b-button
                    type="button"
                    variant="lisaweb"
                    size="sm"
                    @click="onDuplicate"
                    title="Duplica template"
                  >
                    <b-icon icon="files"></b-icon> Duplica
                  </b-button>
                </div>
                <b-button
                  @click="$router.back()"
                  variant="lisaweb"
                  size="sm"
                  class="btn--transparent"
                  title="Torna alla pagina precedente"
                >
                  <b-icon-chevron-double-left
                    font-scale="0.9"
                  ></b-icon-chevron-double-left>
                  Torna indietro
                </b-button>
              </div>
            </div>
          </b-form>
        </validation-observer>
        <duplicate-lisacomunica-template-modal
          :id="duplicateModalId"
          :repository="repository"
          :item="duplicateItem"
          :type-label="typeLabel"
          @duplicated="onDuplicated"
        />
      </div>
      <template #overlay>
        <div class="text-center">
          <base-icon name="loading" width="35" height="35" />
          <p id="cancel-label">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
    <div class="is-saving-template" v-show="isSavingTemplate"></div>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import BaseIcon from "@/components/BaseIcon";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
// import BaseTextarea from "@/components/form/BaseTextarea.vue";
import BaseEditorSms from "@/components/form/BaseEditorSms";
import DuplicateLisacomunicaTemplateModal from "@/components/modals/duplicateLisacomunicaTemplateModal";

export default {
  mixins: [ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      repository: "sms",
      typeLabel: "Sms",
      duplicateModalId: "duplicateSmsEditModal",
      duplicateItem: {},
      isLoading: true,
      isSavingTemplate: false,
      id: this.$route.params.id,
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
      form: {
        sms: {
          title: null,
          type: null,
          text_content: null,
        },
      },
      original_value: null,
      updated_content: null,
      table_row_item: this.$route.params.item ? this.$route.params.item : {},
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    BaseEditorSms,
    DuplicateLisacomunicaTemplateModal,
    // BaseTextarea,
  },
  methods: {
    updateEditorContent(contentHtml) {
      console.log("contentHtml", contentHtml);
      this.updated_content = contentHtml;
    },
    onInitEditEditor() {
      console.log("onInitEditEditor");
      setTimeout(() => {
        this.form[this.rep].text_content = this.original_value;
      }, 300);
    },
    onDuplicate() {
      this.duplicateItem = { id: this.id, title: this.form[this.rep].title };
      this.$bvModal.show(this.duplicateModalId);
    },
    onDuplicated() {
      // /new non restituisce l'id del nuovo template: torniamo all'elenco
      this.shortcut("lisacomunica_template", null, "#Sms", "filterSms");
    },
    stripHtml(html) {
      // SMS templates don't support HTML: keep line breaks, drop tags,
      // and decode entities (&nbsp;, accented chars, &amp;, ...) via the DOM.
      const withBreaks = html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div)>/gi, "\n");
      const tmp = document.createElement("div");
      tmp.innerHTML = withBreaks.replace(/<[^>]*>?/gm, "");
      return tmp.textContent.replace(/\u00a0/g, " ").trim();
    },
    onSubmit() {
      // if (
      //   !this.updated_content ||
      //   this.updated_content === `<p><br data-mce-bogus="1"></p>` ||
      //   this.updated_content === `<p></p>`
      // ) {
      //   this.updated_content = this.original_value;
      // }
      // this.form[this.rep].text_content = this.updated_content;
      const rawTextContent =
        this.get_html_from_iframe("sms_text_content") || "";
      const textContent = this.stripHtml(rawTextContent);
      if (
        !rawTextContent ||
        rawTextContent === `<p><br data-mce-bogus="1"></p>` ||
        rawTextContent === `<p></p>` ||
        !textContent
      ) {
        this.$showSnackbar({
          preset: "error",
          text: `C'è stato un problema durante il salvataggio. Ti preghiamo di riprovare più tardi.`,
        });
        return;
      }
      this.isSavingTemplate = true;
      this.form[this.rep].text_content = textContent;
      this.update()
        .then(() => {
          this.isSavingTemplate = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template Sms Modificato`,
          });
          this.shortcut("lisacomunica_template", null, "#Sms", "filterSms");
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isSavingTemplate = false;
        });
    },
  },
  created() {
    this.show()
      .then((response) => {
        this.initializeEditForm(response.data.content);
        this.original_value =
          this.form[this.rep].text_content ?? this.table_row_item?.text_content;
        this.form[this.rep].text_content = "";
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
        this.ok = true;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
